import { API_ERROR_MESSAGE } from '../../utils/Constants'
import { API_CALL_TYPE, getAPIUrl } from '../API'
import { ProductIds, ReportTypes } from '../apiConstants'
import { makeApiCall } from '../APIService'

interface HandleConsumerTraceLoadReportProps {
  idNumber: string
  passportNumber: string
  xpertConsumer: {
    idno?: any
    passportnumber?: any
    enquiryID?: string
    enquiryResultID?: string
  } | null
  reference: string
  setErrorMessage: (value: string) => void
  setIsError: (value: boolean) => void
  setShowProgress: (value: boolean) => void
  setReportId: (value: string) => void
  reportTypeId: number
  downloadReport: (reportId?: string) => void
  purpose: string
}

export const handleConsumerTraceLoadReport = ({
  idNumber,
  passportNumber,
  xpertConsumer,
  reference,
  setShowProgress,
  setIsError,
  setErrorMessage,
  setReportId,
  reportTypeId,
  downloadReport,
  purpose,
}: HandleConsumerTraceLoadReportProps): void => {
  const API_URL = `${getAPIUrl()}/ConsumerTrace/load-report`
  const body = {
    identityNumber: xpertConsumer?.idno.length
      ? xpertConsumer?.idno
      : xpertConsumer?.passportnumber,
    enquiryId: xpertConsumer?.enquiryID,
    enquiryResultId: xpertConsumer?.enquiryResultID,
    productId: ProductIds.ConsumerTraceReport.productId,
    reference,
    reportType: ReportTypes.ConsumerTraceReport.reportTypeId,
    purpose,
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')
  makeApiCall(
    API_CALL_TYPE.POST_CALL,
    API_URL,
    (response: { statusCode: number; data: { reportId: string } }) => {
      if (response.statusCode !== 200) {
        setIsError(true)
        setErrorMessage(API_ERROR_MESSAGE)
      } else {
        downloadReport(response.data.reportId)
        setReportId(response.data.reportId)
        setShowProgress(false)
      }
    },
    (error: { response: { data: { message: string } } }) => {
      console.log(error)
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
    body,
    {
      Authorization: `Bearer ${sessionStorage.getItem('jwt')}`,
    },
    null,
    false,
  )
}

interface DownloadReportProps {
  reportId: string
  setErrorMessage: (value: string) => void
  setIsError: (value: boolean) => void
  setShowProgress: (value: boolean) => void
  reportTypeId: number
}

export const downloadReport = (props: DownloadReportProps): void => {
  const {
    reportId,
    reportTypeId,
    setShowProgress,
    setIsError,
    setErrorMessage,
  } = props
  const requestOptions: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    body: JSON.stringify({
      reportId,
      reportType: reportTypeId,
    }),
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')

  fetch(`${getAPIUrl()}/ConsumerTrace/download-report`, requestOptions)
    .then((res: Response) => {
      return res.blob()
    })
    .then((blob: Blob) => {
      setShowProgress(false)
      const href = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = href
      link.setAttribute('download', 'ConsumerTraceReport.pdf')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
    .catch((error) => {
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
      return Promise.reject({ Error: 'Something Went Wrong', error })
    })
}

interface SearchConsumerProps {
  idNumber: string
  surname: string
  contactNumber: string
  forename: string
  passportNumber: string
  birthYear: any
  dateOfBirth: any
  prescribedPurposeSelectedOption: string
  reference: string
  searchType: any
  reportType: any
  productId: any
  setErrorMessage: (value: string) => void
  setIsError: (value: boolean) => void
  setShowProgress: (value: boolean) => void
  setXpertConsumers: (data: any) => void
}

export const searchConsumer = ({
  idNumber,
  surname,
  contactNumber,
  forename,
  passportNumber,
  birthYear,
  dateOfBirth,
  prescribedPurposeSelectedOption,
  reference,
  searchType,
  reportType,
  productId,
  setShowProgress,
  setIsError,
  setErrorMessage,
  setXpertConsumers,
}: SearchConsumerProps): void => {
  const API_URL: string = getAPIUrl() + '/ConsumerTrace/search-consumer'
  const body: Record<string, string> = {
    identityNumber: idNumber,
    passportNumber,
    firstName: forename,
    lastName: surname,
    telephone: contactNumber,
    dateOfBirth: dateOfBirth?.length ? dateOfBirth : null,
    birthYear: birthYear.length ? birthYear : null,
    purpose: prescribedPurposeSelectedOption,
    reference,
    searchType,
    reportType,
    productId,
  }
  setShowProgress(true)
  setIsError(false)
  setErrorMessage('')

  makeApiCall(
    API_CALL_TYPE.POST_CALL,
    API_URL,
    (response) => {
      if (response.data.length === 0) {
        setShowProgress(false)
        alert(
          `No results found for: ${idNumber}${passportNumber}${forename} ${surname}`,
        )
      } else {
        setShowProgress(false)
        setXpertConsumers(response.data)
      }
    },
    (error: Error) => {
      console.log(error)
      setShowProgress(false)
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
    body,
    {
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    null,
    false,
  )
}
